import type * as React from 'react';

import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../../../components/ui/card';
import { ServiceActReport } from './service-act-report';

/**
 * Отчёт об оказанных услугах — таблица размещений и Word по форме клиента.
 *
 * Собирается по тем же ссылкам, что презентация: медиаресурс, дату, формат,
 * просмотры и охваты считает InstaFarm. Руками остаются деньги — их API не
 * знает — и строки по публикациям, до которых мы не дотянулись.
 */
export function ActReportCard(): React.ReactElement {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Отчёт об услугах</CardTitle>
        <CardDescription>
          Таблица размещений со стоимостью и экранами статистики — Word по форме
          бухгалтерии клиента.
        </CardDescription>
      </CardHeader>
      <CardContent>
        <ServiceActReport />
      </CardContent>
    </Card>
  );
}
